import {match} from 'ts-pattern'
import {QuestionAmountType, QuestionBounds, QuestionCfg} from './question'
import {DateTime} from 'luxon'

export namespace Bounds {
  export const toTuple = <T extends {min?: number; max?: number}>(
    bounds: T
  ): [T['min'], T['max']] => [bounds?.min, bounds?.max]

  export const defaultForType = (amountType: QuestionAmountType): QuestionBounds =>
    match(amountType)
      .with('number', () => ({
        min: 0,
        max: 100
      }))
      .with('date', () => ({
        min: DateTime.now().startOf('year').toMillis(),
        max: DateTime.now().startOf('year').plus({years: 5}).toMillis()
      }))
      .exhaustive()

  /** derive the current bounds given a fallback  */
  export const withDefaults = (raw: Partial<QuestionBounds> | undefined, fallback?: QuestionBounds) => {
    const bounds = {...defaultForType('number'), ...fallback, ...raw}
    const {min, max} = bounds
    return {bounds, boundsTuple: [min, max] as [number, number]}
  }
}
